/**
 * DIBAI 18K — Catálogo con Sidebar  v2.0.0
 * Filtrado client-side: muestra/oculta productos por colección.
 * Sin recargas de página, sin AJAX.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var page = document.querySelector('.cat-page');
    if (!page) return;

    // ── Inicializar Quick View (reutiliza QV de carrusel-prod-dibai.js) ──────
    // carrusel-prod-dibai.js expone QV como objeto en su scope cerrado
    // En su lugar, re-inicializamos el listener de click para quickview aquí
    initQuickView(page);

    var grid      = page.querySelector('[data-cat-grid]');
    var emptyEl   = page.querySelector('[data-cat-empty]');
    var countEl   = page.querySelector('[data-cat-count]');
    var titleEl   = page.querySelector('[data-cat-title]');
    var sortEl    = page.querySelector('[data-cat-sort]');
    var filterBtns = page.querySelectorAll('[data-cat-filter]');
    var allItems  = Array.from(page.querySelectorAll('.cat-grid__item'));

    // ── Flechas de scroll en móvil ────────────────────────────────────────────
    var navList   = page.querySelector('.cat-nav__list');
    var arrowL    = page.querySelector('.cat-nav__arrow--left');
    var arrowR    = page.querySelector('.cat-nav__arrow--right');

    function updateArrows() {
      if (!navList || !arrowL || !arrowR) return;
      if (window.innerWidth > 989) { arrowL.classList.remove('visible'); arrowR.classList.remove('visible'); return; }
      arrowL.classList.toggle('visible', navList.scrollLeft > 8);
      arrowR.classList.toggle('visible', navList.scrollLeft < navList.scrollWidth - navList.clientWidth - 8);
    }

    if (navList) {
      navList.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    if (arrowL) arrowL.addEventListener('click', function() { navList.scrollBy({ left: -120, behavior: 'smooth' }); });
    if (arrowR) arrowR.addEventListener('click', function() { navList.scrollBy({ left: 120, behavior: 'smooth' }); });

    var currentFilter = 'all';
    var currentSort   = 'default';

    // Guardar orden original para sort "default"
    allItems.forEach(function(item, i) { item.dataset.originalIndex = i; });

    // ── URL sync ─────────────────────────────────────────────────────────────
    function pushFilterUrl(handle) {
      var url = new URL(window.location.href);
      if (handle === 'all') {
        url.searchParams.delete('categoria');
      } else {
        url.searchParams.set('categoria', handle);
      }
      history.pushState({ categoria: handle }, '', url.toString());
    }

    // ── Filtrar ──────────────────────────────────────────────────────────────
    function applyFilter(handle, updateUrl) {
      currentFilter = handle;

      var visible = [];
      allItems.forEach(function(item) {
        var colls = (item.dataset.collections || '').split(' ').filter(Boolean);
        var show  = handle === 'all' || colls.indexOf(handle) !== -1;
        item.style.display = show ? '' : 'none';
        if (show) visible.push(item);
      });

      // Actualizar conteo
      if (countEl) {
        countEl.innerHTML = 'Hay <strong>' + visible.length + '</strong> Producto' + (visible.length !== 1 ? 's' : '') + '.';
      }

      // Mostrar/ocultar estado vacío
      if (emptyEl) emptyEl.hidden = visible.length > 0;

      // Actualizar active state en sidebar
      filterBtns.forEach(function(btn) {
        btn.classList.toggle('is-active', btn.dataset.catFilter === handle);
      });

      // Actualizar título
      if (updateUrl !== false) {
        var activeBtn = Array.from(filterBtns).find(function(b) { return b.dataset.catFilter === handle; });
        if (titleEl) {
          titleEl.textContent = handle === 'all'
            ? (page.querySelector('.cat-sidebar__heading') || {}).textContent || 'Todos los productos'
            : (activeBtn ? activeBtn.textContent.trim() : handle);
        }
        pushFilterUrl(handle);
      }

      // Aplicar sort actual
      applySort(currentSort, false);
    }

    // ── Ordenar ──────────────────────────────────────────────────────────────
    function applySort(sortValue, reFilter) {
      currentSort = sortValue;

      var visibleItems = allItems.filter(function(item) {
        return item.style.display !== 'none';
      });

      visibleItems.sort(function(a, b) {
        switch (sortValue) {
          case 'price-asc':
            return parseInt(a.dataset.price || 0) - parseInt(b.dataset.price || 0);
          case 'price-desc':
            return parseInt(b.dataset.price || 0) - parseInt(a.dataset.price || 0);
          case 'title-asc':
            return (a.dataset.title || '').localeCompare(b.dataset.title || '', 'es');
          case 'title-desc':
            return (b.dataset.title || '').localeCompare(a.dataset.title || '', 'es');
          default:
            return parseInt(a.dataset.originalIndex || 0) - parseInt(b.dataset.originalIndex || 0);
        }
      });

      // Re-insertar en orden
      visibleItems.forEach(function(item) {
        grid.appendChild(item);
      });
    }

    // ── Bind filtros del sidebar ──────────────────────────────────────────────
    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var handle = btn.dataset.catFilter;

        // Animación suave
        if (grid) {
          grid.style.opacity = '0.3';
          grid.style.transition = 'opacity 0.15s ease';
        }

        setTimeout(function() {
          applyFilter(handle);
          if (grid) { grid.style.opacity = '1'; }
        }, 150);
      });
    });

    // ── Botón Atrás / Adelante del navegador ─────────────────────────────────
    window.addEventListener('popstate', function(e) {
      var handle = (e.state && e.state.categoria) || new URL(window.location.href).searchParams.get('categoria') || 'all';
      applyFilter(handle, false); // false = no volver a pushear URL
    });

    // ── Bind sort ─────────────────────────────────────────────────────────────
    if (sortEl) {
      sortEl.addEventListener('change', function() {
        applySort(sortEl.value, false);
      });
    }

    // ── Estado inicial: leer ?categoria= de la URL ───────────────────────────
    var initialFilter = new URL(window.location.href).searchParams.get('categoria') || 'all';
    applyFilter(initialFilter, false); // false = no pushear URL en la carga inicial
    // Reemplazar state actual para que popstate funcione al volver
    history.replaceState({ categoria: initialFilter }, '', window.location.href);

    // Fade in
    if (grid) {
      grid.style.opacity = '0';
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          grid.style.transition = 'opacity 0.4s ease';
          grid.style.opacity = '1';
        });
      });
    }
  });


// ── ATC en catálogo: interceptar submit y abrir cart drawer ─────────────────
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form.classList.contains('cpd-card__form')) return;
  if (!document.querySelector('.cat-page')) return;

  e.preventDefault();

  var btn       = form.querySelector('[data-cpd-atc]');
  var idInput   = form.querySelector('input[name="id"]');
  if (!idInput) return;

  // Spinner
  if (btn) {
    btn.disabled = true;
    var ts = btn.querySelector('.cpd-card__atc-text');
    var sp = btn.querySelector('.cpd-card__atc-spinner');
    if (ts) ts.style.display = 'none';
    if (sp) sp.style.display = 'block';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 })
  })
  .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
  .then(function() {
    // Actualizar bubble
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      document.querySelectorAll('.cart-bubble__text-count').forEach(function(el) {
        el.textContent = cart.item_count;
        var b = el.closest('.cart-bubble');
        if (b) b.classList.toggle('visually-hidden', cart.item_count === 0);
      });
    });

    // Refrescar y abrir cart drawer
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;

    fetch('/?sections=cart-drawer-section')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data['cart-drawer-section'];
        if (html) {
          var doc     = new DOMParser().parseFromString(html, 'text/html');
          var newComp = doc.querySelector('cart-drawer-component');
          var curComp = document.querySelector('cart-drawer-component');
          if (newComp && curComp) curComp.replaceWith(newComp.cloneNode(true));
        }
      })
      .catch(function() {})
      .finally(function() {
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      });
  })
  .catch(function(err) { console.error('[CatalogDibai ATC]', err); })
  .finally(function() {
    if (btn) {
      btn.disabled = false;
      var ts = btn.querySelector('.cpd-card__atc-text');
      var sp = btn.querySelector('.cpd-card__atc-spinner');
      if (ts) ts.style.display = '';
      if (sp) sp.style.display = '';
    }
  });
});


// ── Galería carousel para Quick View ────────────────────────────────────────
function initQVGallery(container) {
  var items  = Array.from(container.querySelectorAll('.ppv2-gallery__item'));
  var thumbs = Array.from(container.querySelectorAll('.ppv2-gallery__thumb'));
  if (!items.length) return;

  var current = 0;

  // Forzar modo carousel: ocultar todos excepto el activo
  function showItem(idx) {
    current = idx;
    items.forEach(function(el, i) {
      el.style.display = i === idx ? 'block' : 'none';
      el.classList.toggle('is-active', i === idx);
    });
    thumbs.forEach(function(t, i) {
      t.classList.toggle('is-active', i === idx);
      t.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
    });
  }

  // Inicializar: mostrar primera imagen
  showItem(0);

  // Click en miniatura → cambiar imagen
  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { showItem(i); });
  });

  // Swipe táctil
  var startX = 0;
  var stack = container.querySelector('.ppv2-gallery__stack') || container;
  stack.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  }, { passive: true });
  stack.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 44) showItem(Math.max(0, Math.min(items.length - 1, current + (dx < 0 ? 1 : -1))));
  });
}


// ── Quick View para la página del catálogo ───────────────────────────────────
function initQuickView(page) {
  // Verificar si el modal existe (renderizado por product-quickview-dibai snippet)
  var modal = document.getElementById('cpd-quickview-modal');
  if (!modal) return;

  var body       = document.getElementById('cpd-quickview-body');
  var lastFocused = null;

  function openQV(handle, sectionUrl) {
    lastFocused = document.activeElement;
    body.innerHTML = '<div class="cpd-qv__loader"><div class="cpd-qv__spinner"></div></div>';
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    var url = sectionUrl || ('/products/' + handle + '?sections=product-dibai-main');
    fetch(url)
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data) throw new Error('no data');
        var html = data['product-dibai-main'] || data[Object.keys(data)[0]];
        if (html) {
          body.innerHTML = '<div class="cpd-qv__product">' + html + '</div>';

          // ── Ajustes vista rápida ──
          var w = body.querySelector('.cpd-qv__product');
          if (w) {
            // 1. Quitar descripción de colección
            w.querySelectorAll('.ppv2-info__collection-desc').forEach(function(el){ el.remove(); });
            // 2. Quitar "Pagando por..."
            w.querySelectorAll('.ppv2-promo-payment').forEach(function(el){ el.remove(); });
            w.querySelectorAll('p').forEach(function(p){
              if (p.textContent.includes('Pagando por')) { var d = p.closest('div'); if(d) d.remove(); }
            });
            // 3. Expandir especificaciones
            w.querySelectorAll('.ppv2-specs-accordion__body').forEach(function(b){
              b.style.maxHeight = 'none'; b.style.overflow = 'visible';
              b.style.display = 'block'; b.style.opacity = '1';
            });
            w.querySelectorAll('.ppv2-specs-accordion__trigger').forEach(function(btn){
              btn.style.pointerEvents = 'none';
              var icon = btn.querySelector('.ppv2-specs-accordion__icon');
              if (icon) icon.remove();
            });

            // 4. Inicializar galería dentro del Quick View (carousel puro)
            initQVGallery(w);
          }
        } else {
          throw new Error('no section html');
        }
      })
      .catch(function() {
        body.innerHTML = '<div style="text-align:center;padding:40px 24px;font-family:Montserrat,sans-serif"><p style="color:#666;margin-bottom:20px">No se pudo cargar el producto.</p><a href="/products/' + handle + '" style="display:inline-block;padding:14px 32px;background:#111;color:#fff;text-decoration:none;font-size:12px;letter-spacing:1.5px;text-transform:uppercase;font-weight:700">VER PRODUCTO</a></div>';
      });
  }

  function closeQV() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  // Cerrar con overlay y botón X
  modal.querySelectorAll('[data-cpd-qv-close]').forEach(function(el) {
    el.addEventListener('click', closeQV);
  });

  // ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !modal.hidden) closeQV();
  });

  // Delegación: clic en cualquier botón de quick view dentro del catálogo
  page.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cpd-quickview]');
    if (!btn) return;
    var handle     = btn.dataset.cpdQuickview;
    var sectionUrl = btn.dataset.productSectionUrl;
    if (handle) openQV(handle, sectionUrl);
  });
}

})();